<!--
 * @Description: 护栏碰撞预警系统
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 18:25:43
 -->
<template>
  <div class="guardrailCollision">
    <div class="platFormIntroduceBtn" @click="detailShowSwitch">平台介绍</div>
    <transition name="el-zoom-in-center">
      <div class="platFormIntroduceDetail" v-if="showDetail">
        <span class="closeBtn el-icon-close" @click="closePdfView"></span>
        <iframe :src="pdfUrl + '#scrollbars=0&toolbar=0&statusbar=0'" frameborder="0" scrolling="no"></iframe>
      </div>
    </transition>
    <div class="line1">
      <Line1 />
    </div>
    <div class="line2">
      <Line2 />
    </div>
    <div class="line3">
      <Line3 />
    </div>
    <div class="line4">
      <div class="line4Left">
        <Line4Left />
      </div>
      <div class="line4Right">
        <Line4Right />
      </div>
    </div>
  </div>
</template>

<script>
import Line1 from './components/line1'
import Line2 from './components/line2'
import Line3 from './components/line3'
import Line4Left from './components/line4Left'
import Line4Right from './components/line4Right'
export default {
  name: 'guardrailCollision',
  components: {
    Line1,
    Line2,
    Line3,
    Line4Left,
    Line4Right,
  },
  data () {
    return {
      showDetail: false,
      pdfUrl: 'https://bigdata-v.prod.hndfsj.net/hlpz.pdf',
    }
  },
  methods: {
    /**
     * @description                   平台介绍详细信息的打开与隐藏
     * @return {undefied}             无返回值
     */
    detailShowSwitch () {
      this.showDetail = !this.showDetail
    },
    /**
     * @description                   关闭平台介绍
     * @return {undefied}             无返回值
     */
    closePdfView () {
      this.showDetail = false
    },
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .guardrailCollision {
    width: 100%;
    height: 100%;
    position: relative;
    .platFormIntroduceBtn {
      display: inline-block;
      width: 132px;
      height: 70px;
      background: url('/static/img/layout/platformIntroduceBg.png');
      background-size: 100% 100%;
      position: absolute;
      top: 300px;
      left: 0;
      text-align: center;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
      line-height: 70px;
      z-index: 100000;
    }
    .platFormIntroduceDetail {
      width: 800px;
      height: 900px;
      padding-top: 30px;
      overflow-y: scroll;
      // background: url('/static/img/layout/platformIntroduceDetailBg.png');
      // background-size: 100% 100%;
      position: absolute;
      top: 150px;
      left: 130px;
      color: #d7fdff;
      font-size: 18px;
      line-height: 24px;
      z-index: 10000;
      .closeBtn {
        display: inline-blockl;
        width: 20px;
        height: 20px;
        cursor: pointer;
        font-size: 30px;
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10000000;
      }
      iframe {
        width: 100%;
        height: calc(100% - 20px);
        border-radius: 10px;
        ::-webkit-scrollbar-thumb {
          cursor: pointer;
          box-shadow: inset 0 0 6px #106669;
          background-color: #05dbe3;
          border-radius: 4px;
        }

        ::-webkit-scrollbar:hover {
          width: 5px;
          height: 10px;
        }

        ::-webkit-scrollbar-corner {
          background-color: #181f27;
        }
      }
    }
    .line1 {
      width: 100%;
      height: 16%;
    }
    .line2 {
      width: 100%;
      height: 44%;
    }
    .line3 {
      width: 100%;
      height: 15%;
    }
    .line4 {
      width: 100%;
      height: 25%;
      >div {
        display: inline-block;
        vertical-align: middle;
      }
      .line4Left {
        width: 46%;
        height: 100%;
      }
      .line4Right {
        width: 46%;
        height: 100%;
        margin-left: 4%;
      }
    }
  }
</style>
